import React from 'react';
import { Info, Bike, Mountain, RoadTraction } from 'lucide-react';

const SurfaceBar = ({ surfaceData }) => {
  if (!surfaceData) return null;

  const paved = surfaceData.paved_pct || 0;
  const unpaved = surfaceData.unpaved_pct || 0;
  const other = Math.max(0, 100 - (paved + unpaved));

  // Lògica de diagnòstic de la ruta
  const getRouteType = () => {
    if (unpaved > 60) return { label: "Ruta Purament MTB", color: "#166534", icon: <Mountain size={16} /> };
    if (unpaved > 30) return { label: "Ruta Mixta / Gravel", color: "#84cc16", icon: <Bike size={16} /> };
    if (paved > 80) return { label: "Ruta de Carretera", color: "#334155", icon: <Bike size={16} /> };
    return { label: "Ruta Híbrida", color: "#64748b", icon: <Bike size={16} /> };
  };

  const routeType = getRouteType();

  return (
    <div className="surface-analysis-card" style={{
      background: 'white',
      padding: '20px',
      borderRadius: '12px',
      boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
      margin: '20px 0'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
        <h3 style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0, fontSize: '1.1rem' }}>
          <Info size={18} color="#64748b" /> Composició del Terreny
        </h3>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          background: routeType.color,
          color: 'white',
          padding: '4px 12px',
          borderRadius: '20px',
          fontSize: '0.85rem',
          fontWeight: '600'
        }}>
          {routeType.icon}
          {routeType.label}
        </div>
      </div>

      <div style={{ height: '14px', display: 'flex', borderRadius: '7px', overflow: 'hidden', background: '#f1f5f9' }}>
        <div style={{ width: `${paved}%`, background: '#475569' }} title={`Asfalt: ${paved}%`} />
        <div style={{ width: `${unpaved}%`, background: '#84cc16' }} title={`Terra: ${unpaved}%`} />
        <div style={{ width: `${other}%`, background: '#cbd5e1' }} title="Altres" />
      </div>

      <div style={{ display: 'flex', gap: '20px', marginTop: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.9rem', color: '#475569' }}>
          <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#475569' }}></div>
          Asfalt <strong>{paved}%</strong>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.9rem', color: '#475569' }}>
          <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#84cc16' }}></div>
          Terra/Camins <strong>{unpaved}%</strong>
        </div>
      </div>
    </div>
  );
};

export default SurfaceBar;